<template>
       <div  class="tutorials_contian">
         <img :src="require('@/assets/introduce/pic1.png')" class="introduce_img"/>
         <img :src="require('@/assets/introduce/pic2.png')" class="introduce_img"/>
         <img :src="require('@/assets/introduce/pic3.png')" class="introduce_img"/>
         <img :src="require('@/assets/introduce/pic4.png')" class="introduce_img"/>
         <img :src="require('@/assets/introduce/pic5.png')" class="introduce_img"/>
         <img :src="require('@/assets/introduce/pic6.png')" class="introduce_img"/>
         <img :src="require('@/assets/introduce/pic7.png')" class="introduce_img"/>
         <img :src="require('@/assets/introduce/pic8.png')" class="introduce_img"/>
                    <div class="agreement_box">
             <a href="https://ottepg-moss.cedock.com/tvhelper/agreement/useragreement.html" target="_blank">用户协议</a>｜<a href="https://ottepg-moss.cedock.com/tvhelper/agreement/privacyagreement.html" target="_blank">隐私政策</a>
           </div>
        <div class="apkload_button" @click="downloadapk"  v-if="isMobile">下载欢视助手TV版</div>
        <div style="height: 30px;width: 320px;" v-if="isMobile"></div>
       </div>
</template>

<script>
export default {
  name: "tutorials",
  data() {
    return {
      isMobile:false
    }
  },

  mounted() {
    let userAgent = navigator.userAgent;
    this.isMobile = /mobile|android/i.test(userAgent);
  },
  methods: {
    downloadapk(){
      const url='https://dl-appstore.huan.tv/project/ott/tvhelper/TVhelper_general_1.0.0_20231023174019_release.apk';
      const link = document.createElement('a');
      link.href = url;
      link.download = ''; // 可选，设置下载文件的名称
      link.click();
    },
  }
}
</script>

<style scoped>
.tutorials_contian{
  width: 90%;
  padding: 0 5%;
  height: auto;
  max-width: 1398px;
  margin-top: 110px;
}
.introduce_img{
  width: 100%;
  height: auto;
}
.agreement_box{
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #747F97;
  text-align: center;
  margin-bottom: 1%;
  margin-top: 3%;

}
.agreement_box a{
  color: #747F97;
  text-decoration: none;
}

@media screen and (max-width: 600px) {

  .tutorials_contian{
    width: 90%;
    padding: 0 5%;
    height: 100%;
       position: absolute;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 150px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;
  }
  .apkload_button{
    width: 90%;
    height: 40px;
    line-height: 40px;
    background-color: #1457EF;
    border-radius: 20px;
    text-align: center;
    font-size: 16px;
    color: #ffffff;
    margin-top: 3%;

  }
  .apkload_button:hover {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tutorials.vue